import MyAccountComponent from './MyAccount';
import ManageDevicesComponent from './ManageDevices';

export enum Menu {
  MyAccount = 'myAccount',
  ManageDevices = 'manageDevices',
}

export type MenuItemBaseProps = {
  icon: React.FC;
  link: string;
  label: string;
  isVisible: boolean;
};

export type MenuItem<T extends Menu, C extends React.ComponentType<any>> = MenuItemBaseProps & {
  value: T;
  component: C;
};

type MenuConfigMap = {
  [Menu.MyAccount]: {
    component: typeof MyAccountComponent;
    icon: React.FC;
    label: string;
    link: string;
  };
  [Menu.ManageDevices]: {
    component: typeof ManageDevicesComponent;
    icon: React.FC;
    label: string;
    link: string;
  };
};

type MenuItemFromConfig = {
  [K in keyof MenuConfigMap]: MenuItem<K, MenuConfigMap[K]['component']>;
};

export type MenuItemProps = MenuItemFromConfig[keyof MenuConfigMap];
